import { isBoolean } from 'lodash'
import { Maybe } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'

export const getLoadType = (
  isPickupDropTrailer: Maybe<boolean>,
  isDeliveryDropTrailer: Maybe<boolean>
): string => {
  if (!isBoolean(isPickupDropTrailer) || !isBoolean(isDeliveryDropTrailer)) {
    return DISPLAY.empty
  }

  const pickupLoadType = isPickupDropTrailer ? 'Drop' : 'Live'
  const deliveryLoadType = isDeliveryDropTrailer ? 'Drop' : 'Live'

  return `${pickupLoadType} - ${deliveryLoadType}`
}
